export const problematicDeptCertificatesFilters = () => {
  const currentYear = new Date().getFullYear();

  const years = [{
    key: 'Όλα',
    value: 0,
  }];

  const yearList = Array.from({ length: currentYear - 2015 + 1 }, (_, index) =>
    (2015 + index).toString(),
  );

  yearList.forEach((y) => {
    years.push({key: `${y}`, value: y,});
  });

  return [
    {
      control: 'autocomplete',
      label: 'Κατάσταση',
      name: 'status',
      options: [
        { key: 'Σε Αναμονή', value: 0 },
        { key: 'Μη Επιβεβαιωμενο', value: 1 },
        { key: 'Μη Εξοφλημένο', value: 2 },
        { key: 'Εξοφλημένο', value: 3 },
        { key: 'Μη Τερματικό Σφάλμα', value: 4 },
        { key: 'Τερματικό Σφάλμα', value: 5 },
        { key: 'Μη έγκυρος ΑΦΜ', value: 6 },
      ],
    },
    {
      control: 'select',
      label: 'Έτος',
      name: 'year',
      options: years,
    },
  ];
};
